<template>
  <div>

    <TitlePage :title="$t('blacklist')"></TitlePage>

    <v-row class="align-center">

      <v-col cols="12" md="6">
        <v-btn elevation="2" color="secondary" small class="mr-2" @click="create()">
          <v-icon left>mdi-plus</v-icon>
          {{ $t('create') }}
        </v-btn>
      </v-col>

      <v-col cols="12" md="6">
        <v-text-field v-model="search" append-icon="mdi-magnify" :label="$t('filterResults')" hide-details dense></v-text-field>
      </v-col>
      <v-col cols="12" md="12">
        <ItemActions :selected="selected" @message="actionHandler" :delete-permission="false"></ItemActions>
      </v-col>
    </v-row>

    <v-card tile>
      <v-row class="mt-0 pl-4 pr-4 pb-2 align-center">

        <v-col cols="12" md="3" class="pt-2 pb-0">
          <v-text-field v-model="filter.search" :label="$t('search')" hide-details dense outlined clearable></v-text-field>
        </v-col>

        <v-col cols="12" md="3" class="pt-2 pb-0" v-if="getUser.super_admin">
          <CenterSelectSearch
              v-model="filter.center_id"
              :multiple="false"
              :includeAllOption="true"
              autoStrategy="user"
              :returnObject="false"
              @message="(val) => filter.center_id = val"
          />
        </v-col>

        <v-col cols="12" md="3" class="pt-2 pb-0">
          <v-select :items="statuses" label="Stato" item-text="text" item-value="value" v-model="filter.status" outlined dense hide-details hide-selected></v-select>
        </v-col>

        <v-spacer />

        <v-col cols="12" md="3" class="text-right">
          <v-btn small color="error" @click="resetFilter">
            <v-icon left small>mdi-restore</v-icon> RESET
          </v-btn>
        </v-col>

      </v-row>

    </v-card>


    <div class="mt-5">
      <div style="text-align: right;font-size: 11px;font-weight: 600;padding-bottom: 5px;">
        <span>{{(items_count) ? items_count:0}} risultati trovati</span>
      </div>
      <v-data-table
          v-model="selected" :headers="headers" :items="items"
          :single-select="false" item-key="_id" show-select class="elevation-1" :search="search"
          disable-pagination hide-default-footer
      >

        <template v-slot:item.name="{ item }">
          <strong @click="edit(item._id, item.blacklists._id)" style="cursor:pointer;">
            {{ item.name }} {{item.surname}} - {{item.email}} - {{item.phone}}
          </strong>
        </template>

        <template v-slot:item.b_status="{ item }">
          <template v-if="item.blacklists.status === 'to_be_approved'">
            <v-chip color="orange" text-color="white" small>In Revisione</v-chip>
          </template>
          <template v-else-if="item.blacklists.status === 'active'">
            <v-chip color="error" text-color="white" small>Bloccato</v-chip>
          </template>
          <template v-else-if="item.blacklists.status === 'canceled'">
            <v-chip color="grey" text-color="white" small>Riabilitato</v-chip>
          </template>
        </template>

        <template v-slot:item.b_active="{ item }">
          <template v-if="item.active">
            SI
          </template>
          <template v-else>
            NO
          </template>
        </template>

        <template v-slot:item.b_blocked="{ item }">
          <template v-if="item.blocked">
            SI
          </template>
          <template v-else>
            NO
          </template>
        </template>

        <template v-slot:item.b_created_at="{ item }">
          {{new Date(item.blacklists.created_at).toLocaleString()}}
        </template>

        <template v-slot:item.center="{ item }">
          {{getCenter(item.blacklists.center_id)}}
        </template>


        <template v-slot:item.action="{ item }">
          <v-menu bottom left>

            <template v-slot:activator="{ on, attrs }">
              <v-btn icon v-bind="attrs" v-on="on" color="primary">
                <v-icon>mdi-dots-vertical</v-icon>
              </v-btn>
            </template>

            <v-list dense>
              <v-list-item @click="edit(item._id, item.blacklists._id)" :title="$t('edit')" dense>
                <v-list-item-title>
                  <v-icon dense color="primary" class="mr-3">mdi-file-edit</v-icon>{{ $t('edit') }}
                </v-list-item-title>
              </v-list-item>
              <v-list-item @click="confirmRemove(item._id, item.blacklists._id)" :title="$t('delete')" v-if="getUser.super_admin">
                <v-list-item-title>
                  <v-icon dense color="primary" class="mr-3">mdi-delete</v-icon>{{ $t('delete') }}
                </v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </template>

      </v-data-table>
      <div class="text-center pt-3 pb-3">
        <v-row>
          <v-col cols="12" md="10" style="text-align: end">
            <v-pagination
                v-model="options_pagination.page"
                :length="calculatePagination(items_count,options_pagination.limit)"
                :total-visible="10"
                @input="getNewPage()"
            ></v-pagination>
          </v-col>
          <v-col cols="12" md="2">
            <v-select
                v-model="options_pagination.limit"
                :items="items_for_page"
                label="Risultati per pagina"
                dense hide-details small-chips outlined @change="makeSearch(true)"/>
          </v-col>
        </v-row>
      </div>
    </div>

    <ModalDelete :modalDelete="modalDelete" @message="removeHandler"></ModalDelete>

  </div>

</template>

<script>

import TitlePage from "@/components/utils/TitlePage";
import {mapGetters, mapMutations, mapActions} from 'vuex';
import ModalDelete from "@/components/layout/ModalDelete.vue";
import ItemActions from "@/components/layout/ItemActions.vue";
import SportsAutocompleteSingle from "@/components/admin/SportsAutocompleteSingle";
import CenterAutocomplete from "@/components/admin/CenterAutocomplete.vue";
import CenterSelectSearch from "@/components/filters/CenterSelectSearch.vue";
const exportService = require('@/services/export')

export default {
  name: 'Fields',
  components: {CenterSelectSearch, CenterAutocomplete, SportsAutocompleteSingle,ItemActions, ModalDelete, TitlePage},
  data() {
    return {
      field_list : [],
      field_complete_list: [],
      pathCreate: `/blacklists/create/`,
      pathEdit:  `/blacklists/edit/`,
      search: '',
      selected: [],
      headers: [
        { text: this.$t('name'), align: 'start', value: 'name'},
        { text: this.$t('sportCenter'), align: 'start', value: 'center'},
        { text: this.$t('status')+' Blacklist', align: 'start', value: 'b_status'},
        { text: 'Attivo', align: 'start', value: 'b_active'},
        { text: 'Bloccato', align: 'start', value: 'b_blocked'},
        { text: this.$t('creation_date'), align: 'start', value: 'b_created_at'},
        { text: this.$t('actions'), align: 'start', value: 'action', sortable: false},
      ],
      items: [],
      items_count: 0,
      ids_to_delete: [],
      modalDelete: false,
      typeDelete: '',
      filter: {},
      options_pagination: {},
      items_for_page:[10, 20, 25, 50, 75, 100],
      tree: null,
      statuses: [
          {value:'to_be_approved',text:'In Revisione'},
          {value:'active',text:'Bloccato'},
          {value:'canceled',text:'Riabilitato'},
      ]
    };
  },
  async created(){
    this.filter = Object.assign({},this.getFilter)
    this.options_pagination = Object.assign({},this.getOptionsPagination)

    if(!this.getUser.super_admin){
      delete this.filter.center_id
    }

    if(this.$route.query && this.$route.query.search){
      this.filter.search = this.$route.query.search
    }
    this._debouncedSearch = this.debounce(async () => { await this.makeSearch(); }, 350);
  },
  watch: {
    filter: {
      handler() {
        this._debouncedSearch();
      },
      deep: true
    },
  },
  computed: {
    ...mapGetters({
      'getFilter':'blacklists/getFilter',
      'getOptionsPagination':'blacklists/getOptionsPagination',
      'getUser':'user/getUser'
    }),
  },
  methods: {
    ...mapMutations({
      'setLoading': 'settings/setLoading',
      'setNotification': 'settings/setNotification',
    }),

    ...mapActions({
      'getItems': 'blacklists/index',
      'updateItem':'blacklists/update',
      'deleteItem': 'blacklists/delete',
      'massiveDeleteItem': 'blacklists/massDelete',
      'setFilter': 'blacklists/setFilter',
      'setOptionsPagination': 'blacklists/setOptionsPagination',
    }),

    debounce(fn, wait){
      var t=null; return function(){ var ctx=this,args=arguments;
        clearTimeout(t); t=setTimeout(function(){ fn.apply(ctx,args); }, wait);
      };
    },
    async resetFilter(){
      let filters = Object.assign({},this.getFilter)
      for (const property in filters) {
        filters[property] = null
      }
      this.filter = Object.assign({}, filters)
      this.options_pagination = Object.assign({},{
        page: 1,
        limit: 10
      })
      await this.makeSearch()
    },
    async makeSearch(reset = null) {
      this.setLoading(true);

      if(reset){
        this.options_pagination.page = 1
      }

      await this.setFilter(this.filter)
      await this.setOptionsPagination(this.options_pagination)
      let results = await this.getItems();

      this.items = results.items.results
      this.items_count = results.items.count
      this.tree = results.tree
      this.setLoading(false);
    },

    async actionHandler(type) {
      switch (type) {
        case "edit":
          await this.edit(this.selected[0]._id)
          break;
        case "massiveDelete":
          await this.confirmMassiveRemove()
          break;
        case "export":
          await this.export()
          break;
        default:
          break
      }
    },

    edit(id, bl_id){
      this.$router.push(this.pathEdit+id+'/'+bl_id)
    },

    create(){
      this.$router.push(this.pathCreate)
    },

    confirmRemove(id, bl_id){
      this.ids_to_delete = [id, bl_id]
      this.modalDelete = true
      this.typeDelete = 'single'
    },

    confirmMassiveRemove(){
      this.ids_to_delete = this.selected.map(x => x._id)
      this.modalDelete = true
      this.typeDelete = 'massive'
    },

    async export(){
      let csv = await exportService.getCsv(this.headers, this.items)
      let encodedUri = encodeURI(csv);
      let link = document.createElement("a");
      link.setAttribute("href", encodedUri);
      link.setAttribute("download", `export_${new Date().toISOString()}.csv`);
      document.body.appendChild(link); // Required for FF
      link.click();
    },

    async removeHandler(mode){
      if(this.typeDelete === 'single'){
        await this.remove(mode)
      }else if(this.typeDelete === 'massive'){
        await this.massiveRemove(mode)
      }else {
        this.modalDelete = false
        this.ids_to_delete = []
        this.typeDelete = ''
      }
    },

    async remove(mode){

      if(!mode){

        this.modalDelete = false

      }else{

        this.modalDelete = false
        this.setLoading(true);

        let result = await this.deleteItem({customer_id:this.ids_to_delete[0], id: this.ids_to_delete[1]})

        if(result.success){

          this.setNotification({
            active: true,
            color: 'success',
            mode: 'multi-line',
            text: this.$t('deleteSuccess')
          })

          await this.makeSearch()

          this.setLoading(false);

        }else {

          this.setNotification({
            active: true,
            color: 'error',
            mode: 'multi-line',
            text: result
          })

          this.setLoading(false);
        }
      }

    },
    async massiveRemove(mode){
      if(!mode){

        this.modalDelete = false

      }else{

        this.modalDelete = false
        this.setLoading(true);

        let result = await this.massiveDeleteItem({_id:{$in:this.ids_to_delete}})

        if(result.success){

          this.setNotification({
            active: true,
            color: 'success',
            mode: 'multi-line',
            text: this.$t('deleteSuccess')
          })

          await this.makeSearch()

          this.selected = []
          this.ids_to_delete = []

          this.setLoading(false);

        }else {

          this.setNotification({
            active: true,
            color: 'error',
            mode: 'multi-line',
            text: result
          })

          this.setLoading(false);
        }
      }
    },

    async setCenterId(id) {
      this.filter.center_id = id
    },
    async getNewPage(){
      await this.makeSearch();
    },
    calculatePagination(count, limit){

      let divide = (count / limit)
      let rest = divide % 1

      if(rest > 0){
        divide = divide - rest
        divide = +divide.toFixed(0) + 1
      }

      return +divide
    },
    getCenter(field_id) {
        let check = this.tree.find((el)=> el.center_id.toString() === field_id.toString())
        if(check){
          return check.center_name
        }else {
          return ''
        }
    },
  },
  mounted() {

  },
}
</script>
